import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { SpacingUnit, SpacingRow } from 'components/ui';
import { ChangeIndicator } from 'entities/TableCellActivity';

import { Wrapper } from '../Wrapper';
import { ActivityRendererProps } from '../types';

import s from './ChangeActivity.module.scss';

const ICONS_MAPPER: Record<ChangeIndicator, React.ReactElement> = {
  [ChangeIndicator.arrowDown]: (
    <ArrowDownOutlined
      className={s.changeActivity__activity_indicator_down}
      key={ChangeIndicator.arrowDown}
    />
  ),
  [ChangeIndicator.arrowUp]: (
    <ArrowUpOutlined
      className={s.changeActivity__activity_indicator_up}
      key={ChangeIndicator.arrowUp}
    />
  ),
};

const ChangeActivity: React.FC<ActivityRendererProps> = ({
  entity,
  onDelete,
  onEdit,
}) => {
  return (
    <Wrapper
      onEdit={onEdit}
      onDelete={onDelete}
      icon={<EditOutlined className={s.changeActivity__activityIcon} />}
      entity={entity}
    >
      <div className={s.changeActivity__activity}>
        {entity.edits?.map((item) => (
          <SpacingRow
            key={`${item.formFieldId}-${item.prevValue}-${item.currValue}`}
            hSpacing={SpacingUnit.unit2}
          >
            {item.label}{' '}
            <Typography.Text className={s.changeActivity__valuePrevious}>
              {item.prevValue ?? '?'}
            </Typography.Text>{' '}
            <Typography.Text className={s.changeActivity__valueCurrent}>
              {item.currValue ?? '?'}
            </Typography.Text>
            {item.icons.map((item) => ICONS_MAPPER[item.kind])}
          </SpacingRow>
        ))}
      </div>
    </Wrapper>
  );
};

export default observer(ChangeActivity);
